import { inject, DestroyRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CookieConsentDialogComponent } from './cookie-consent-dialog.component';

export function useCookieConsentDialog() {
  const dialog = inject(MatDialog);
  let dialogRef: MatDialogRef<CookieConsentDialogComponent> | undefined;

  inject(DestroyRef).onDestroy(() => {
    dialogRef?.close();
  });

  function open() {
    if (hasConsent()) {
      return;
    }

    setTimeout(() => {
      if (hasConsent()) return;

      dialogRef = dialog.open(CookieConsentDialogComponent, {
        width: '640px',
        height: '534px',
        panelClass: ['cookie-dialog-panel'],
        disableClose: true,
        hasBackdrop: true
      });

      dialogRef.afterClosed().subscribe(_result => {
      });
    }, 7000);
  }

  function hasConsent(): boolean {
    return localStorage.getItem('cookieConsent') !== null;
  }

  function getConsentValue(): string | null {
    return localStorage.getItem('cookieConsent');
  }


  return {
    open,
    hasConsent,
    getConsentValue
  };
}
